import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'confirm-program-action-dialog',
    template: `
      <div class="dashboard_dialog joi-dialog">
          <div mat-dialog-title class="warn">Delete Day</div>
          <div mat-dialog-content>
              <div class="dialog_content">
                  <div class="para">{{confirm_message}}</div>
                  <div class="para" *ngIf="subsequent_days">Subsequent days will shift back into it's place</div>
                  <div class="note" *ngIf="following_message">
                      <div class="head2">Important:</div>
                      <div class="desc">{{following_message}}</div>
                  </div>
              </div>
          </div>
          <div mat-dialog-actions>
              <button mat-button (click)="dialogRef.close()">Cancel</button>
              <button mat-button color="warn" (click)="confirm()">{{confirm_button}}</button>
          </div>
      </div>

  `,
    styles: [`
      .dashboard_dialog .para { margin-bottom: 15px; }
      .dashboard_dialog .note { margin-bottom:30px; }
      .dashboard_dialog .head2 { text-transform: uppercase; font-weight:bold; color: #F05454;line-height: 20px; }
      .dashboard_dialog .desc { line-height: 20px; }
      `],
    standalone: true,
    imports: [MatButtonModule, MatDialogModule, CommonModule],
})
export class ConfirmProgramActionDialogComponent {

  confirm_message;
  confirm_button;
  following_message;
  subsequent_days;
  lane;
  idx;
  name;

  constructor(public dialogRef: MatDialogRef<ConfirmProgramActionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    const pre = data.type === 'out-of-session' ? 'Out-Of-' : '';
    if (data.num_following) {
      this.following_message = 'All sessions on this day will also be deleted. If you want to keep any of these sessions, click CANCEL and move them to a different day.'
    }
    this.subsequent_days = data.subsequent_days;
    this.confirm_message = data.type === 'day'
      ? 'Are you sure you want to delete this day?'
      : 'Closing this event means that it becomes permanently read-only';
    this.confirm_button = data.type === 'day'
      ? 'Delete Day'
      : 'Delete ' + pre + 'Session';
  }

  confirm() {
    this.dialogRef.close({ confirmed: true, lane: this.data.lane, idx: this.data.idx, num_following: this.data.num_following });
  }
}
